import React from 'react';

import { getFormattedWeightNumber, getUnitConversion } from '../vignette.utils';
import { useTranslation } from 'react-i18next';

const CustomTooltip = ({ slice }) => {
  const { t } = useTranslation();
  const year = slice?.points[0]?.data?.x;

  const sortedData = [...slice?.points].reverse();

  return (
    <div
      style={{
        background: 'white',
        padding: '9px 12px',
        border: '1px solid #ccc',
      }}
    >
      <div style={{ fontWeight: '700' }}>
        {t('APP.SIMULATOR_GRAPHIC.LINE_GRAPHIC.YEARS', {
          defaultValue: 'Année :',
        })}{' '}
        {year}
      </div>
      {sortedData.map((point) => (
        <div
          key={point?.id}
          style={{
            color: 'black',
            padding: '3px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <div
            style={{
              width: '12px',
              height: '12px',
              backgroundColor: point?.serieColor,
              paddingRight: '12px',
              marginRight: '12px',
            }}
          ></div>
          <div>{point.serieId} :&nbsp;</div>
          {getFormattedWeightNumber(Number(point?.data?.yFormatted))}{' '}
          {getUnitConversion(point?.data?.yFormatted)}
        </div>
      ))}
    </div>
  );
};

export default CustomTooltip;
